import React from "react";
import { connect } from "react-redux";
import { setFinanceTerm, setServiceTerm } from "../redux/actions";
import { OnBlurInput } from "./OnBlurInput";
import { Form, Row, Col, InputGroup } from "react-bootstrap";
import {isServiceTermValid, validateServiceTerm} from "../redux/selectors"
import {CFNZ_FINANCE_TERM, IS_NZ} from "../constants"

function ServiceTerm({
  serviceTerm,
  financeType,
  setServiceTerm,
  setFinanceTerm,
  isServiceTermValid,
  validateServiceTerm
}) {
  return (
    <>
      <Form.Group as={Row} controlId="financeSubtype">
        <Form.Label sm={2} column>
          Service Term
        </Form.Label>
        <Col sm={2}>
        <InputGroup>
            <Form.Control
                  as={OnBlurInput}
                  type="number"
                  value={serviceTerm}
                  onConfirm={e => {setServiceTerm(e.target.value);setFinanceTerm(e.target.value)}}
                  min={CFNZ_FINANCE_TERM.min}
                  max={CFNZ_FINANCE_TERM.max}
                  isInvalid={!isServiceTermValid}
                  disabled={financeType !== "CASH"}
                />
            <InputGroup.Prepend>
              <InputGroup.Text>Months</InputGroup.Text>
            </InputGroup.Prepend>
          </InputGroup>
        </Col>
        {!isServiceTermValid ?
        <Col sm={4}>
          <span style={{color: "red", fontWeight: "bold"}}>{validateServiceTerm}</span>
        </Col>
        : null}
        {financeType !== "CASH" && isServiceTermValid ?
        <Col sm={4}>
          <span style={{color: "grey"}}>When using finance, service term will match finance term {IS_NZ ? "set below" : "as returned from Originator"}</span>
        </Col>
        : null}
      </Form.Group>
    </>
  );
}

export default connect(
  state => ({
    serviceTerm: state.quote.serviceTerm,
    financeType: state.quote.finance.financeType,
    isServiceTermValid: isServiceTermValid(state),
    validateServiceTerm: validateServiceTerm(state),
  }),
  { setServiceTerm, setFinanceTerm }
)(ServiceTerm);
